import React, { useRef } from 'react'
import "./footer.scss"
import {Menubar} from 'primereact/menubar';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import CustomIcon from "@Components/icon/icon";
import { useNavigate } from 'react-router-dom';
import { AppRouteURL } from '@Src/routes/app-route-urls';
import { FooterListModel } from './classes/list-models';
import { OverlayPanel } from 'primereact/overlaypanel';
import { FomratName } from '@Constants/constants';

export const Footer = (props: any) => {
    const navigate = useNavigate();
    const appStoreref: any = useRef<OverlayPanel>(null);

    return (
        <>
        <footer className='footer-section print-hidden'>
            <div className='need-asst-footer-card'>
            <p className="text=p1"> Need help with your purchase? Our support team is just a call away!  </p>
<p className="text=p2"> Dial 011-40749922 for immediate assistance. </p>
            </div>

            <div className='footer-rows footer-top-section'>
                <div className='cols-1 colls-ui'>

                    <div className="footer-logo" onClick={() => navigate('')}>
                        <img className='logo'
                            src='https://cdn.taxmann.com/taxmann-images/logos/cacs-logo.webp' />
                    </div>
                   {/*  <p className='footer-title'>
                        Everything you need on Tax & Corporate Laws. Authentic Databases, Books, Journals, Practice Modules, Exam Platforms, and More.
                    </p>
*/}

                    <div className="support-msg m-none">
                        <ul className="support-contents">
                            <li><span>Email: <a href='mailto:students@taxmann.com'> students@taxmann.com</a></span></li>
                            <li><span>Phone: <a href="tel:01140749922"> 011-40749922 </a> </span></li>
                            <li><span>Address: <a target='_blank' href='https://www.google.com/maps/place/Taxmann+(Sales+%26+Marketing)/@28.659091,77.1880582,17z/data=!3m1!4b1!4m6!3m5!1s0x390cfd309eebed77:0xb55e0229bbae72d3!8m2!3d28.6590863!4d77.1906331!16s%2Fg%2F1tgr_9qj?entry=ttu' className=''>59/32 New Rohtak Road <br/>
New Delhi – 110005 <br/>
India</a></span>
                            </li>
                        </ul>
                    </div>

                </div>
                <div className='cols-2 colls-ui'>
                    <ul className="footer-links">
                        <li className="footer-liks-h1">Quick Links</li>
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.ABOUT_US} >About Us</a></li>
                        <li><a href="/students/faqs" >FAQs</a></li>
                        <li><a href="/sitemap" >Sitemap</a></li>
                        <li><a href="/students/contact-us" >Contact Us</a></li>
                    </ul>
                    <ul className="footer-links">
                        <li className="footer-liks-h1">Authors</li>
                        <li><a href={`/students${AppRouteURL.AUTHORS_LIST}`} onClick={() => navigate(AppRouteURL.AUTHORS_LIST)}>A - Z</a></li>
                    </ul>
                </div>
                <div className='cols-3 colls-ui'>
                    <ul className="footer-links">
                        <li className="footer-liks-h1">Products & Services</li>
                        <li><a href={AppRouteURL.BASE_URL+ '/' + AppRouteURL.BOOK + '/format/' + '1-' + FomratName['1'] + '?format=' + '1-' +FomratName['1'] } >Books</a></li>
                        <li><a href={AppRouteURL.BASE_URL+ '/' + AppRouteURL.BOOK + '/format/' + '2-' + FomratName['2'] + '?format=' + '2-' +FomratName['2'] } >Virtual Books</a></li>
                        <li><a href={AppRouteURL.BASE_URL +  '/' + AppRouteURL.VIDEO } >Video Classes</a></li>

                    </ul>

                </div>
                <div className='cols-4 colls-ui'>
                    <ul className="footer-links">
                        <li className="footer-liks-h1">Legal</li>
                        <li><a href="/legal/fair-usage-policy"  >Fair Usage Policy </a></li>
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.PRIVACY_POLICY}  >Privacy Policy </a></li>
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.RETURN_POLICY}  >Return Policy </a></li>
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.PAYMENT_TERMS}  >Payment Terms </a></li>                        
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.EULA}  >EULA </a></li>
                        <li><a href={AppRouteURL.BASE_URL+AppRouteURL.DISCLAIMER}  >Disclaimer </a></li>
                    </ul>
                </div>
                <div className="support-msg l-none">
                       
                <ul className="support-contents">
                            <li><span>Email: <a href='mailto:students@taxmann.com'> students@taxmann.com</a></span></li>
                            <li><span>Phone: 011-40749922 </span></li>
                            <li><span>Address: 59/32 New Rohtak Road <br/>
New Delhi – 110005 <br/>
India</span>
                            </li>
                        </ul>
                    </div>


            </div>

            <div className='footer-btm-sec'>
                <div className='ftr-btn-left-card'>© 2024 Taxmann, Inc.</div>
                <div className='ftr-btn-right-card'>
                    <a target='_blank' href='https://www.instagram.com/taxmann_students/' title="Instagram">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.7144 8.43494C16.6045 8.16016 16.471 7.95604 16.2591 7.74249C16.0455 7.53052 15.8398 7.39706 15.5666 7.28714C14.7706 6.97154 12.8832 7.0422 12.0024 7.0422C11.1183 7.0422 9.23101 6.97154 8.43651 7.28714C8.16016 7.39706 7.95603 7.53052 7.74563 7.74249C7.53209 7.95604 7.39705 8.16016 7.28871 8.43494C6.97468 9.23101 7.04534 11.1184 7.04534 11.9992C7.04534 12.8816 6.97468 14.769 7.28871 15.5651C7.39705 15.8398 7.53209 16.044 7.74563 16.2544C7.9576 16.4695 8.16173 16.6029 8.43651 16.7113C9.23101 17.0269 11.1183 16.9547 12.0024 16.9547C12.8832 16.9547 14.7706 17.0269 15.5666 16.7113C15.8414 16.6029 16.0471 16.4695 16.2591 16.2544C16.471 16.0424 16.6045 15.8383 16.7144 15.5651C17.03 14.769 16.9594 12.8816 16.9594 11.9992C16.9609 11.1184 17.03 9.23101 16.7144 8.43494ZM12.0024 15.1003C10.2862 15.1003 8.8997 13.7154 8.8997 11.9992C8.8997 10.2846 10.2862 8.8997 12.0024 8.8997C13.717 8.8997 15.1019 10.2846 15.1019 11.9992C15.1019 13.7154 13.717 15.1003 12.0024 15.1003ZM15.2275 9.49637C14.8271 9.49637 14.5052 9.17292 14.5052 8.77252C14.5052 8.37056 14.8271 8.04868 15.2275 8.04868C15.6294 8.04868 15.9513 8.37056 15.9513 8.77252C15.9513 9.17292 15.6294 9.49637 15.2275 9.49637ZM12.0024 9.98469C10.8922 9.98469 9.98783 10.8891 9.98783 11.9976C9.98783 13.1078 10.8922 14.0122 12.0024 14.0122C13.1109 14.0122 14.0153 13.1078 14.0153 11.9976C14.0169 10.8907 13.1109 9.98469 12.0024 9.98469ZM12.0024 0C5.3841 0 0 5.38253 0 11.9992C0 18.6159 5.3841 24 12.0024 24C18.619 24 24.0016 18.6159 24.0016 11.9992C24.0016 5.38253 18.619 0 12.0024 0ZM18.0067 14.4926C17.9596 15.4599 17.7382 16.3187 17.0316 17.0269C16.3235 17.735 15.4661 17.9549 14.4973 18.002C13.6636 18.0491 12.8377 18.0412 12.0039 18.0412C11.1702 18.0412 10.3411 18.0491 9.50893 18.002C8.54171 17.9549 7.6844 17.735 6.97625 17.0269C6.26654 16.3187 6.04671 15.4599 6.00118 14.4926C5.9525 13.6605 5.96035 12.833 5.96035 11.9992C5.96035 11.1655 5.9525 10.3395 6.00118 9.50579C6.04671 8.53857 6.26654 7.67968 6.97625 6.97154C7.6844 6.26339 8.54171 6.04357 9.50893 5.99647C10.3411 5.94936 11.1702 5.95721 12.0039 5.95721C12.8377 5.95721 13.6636 5.94936 14.4973 5.99647C15.4661 6.04357 16.3235 6.26339 17.0316 6.97154C17.7382 7.67968 17.9596 8.53857 18.0067 9.50579C18.0522 10.3395 18.0444 11.1655 18.0444 11.9992C18.0444 12.833 18.0522 13.6605 18.0067 14.4926Z" fill="#98A2B3" />
                        </svg>
                    </a>
                    <a target='_blank' href='https://www.facebook.com/TaxmannStudents/ ' title="Facebook">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
             <g clip-path="url(#clip0_1701_13593)">
             <path d="M24 12.4443C24 5.81691 18.6274 0.444336 12 0.444336C5.37258 0.444336 0 5.81691 0 12.4443C0 18.4338 4.3882 23.3983 10.125 24.2986V15.9131H7.07812V12.4443H10.125V9.80059C10.125 6.79309 11.9166 5.13184 14.6576 5.13184C15.9701 5.13184 17.3438 5.36621 17.3438 5.36621V8.31934H15.8306C14.34 8.31934 13.875 9.24441 13.875 10.1943V12.4443H17.2031L16.6711 15.9131H13.875V24.2986C19.6118 23.3983 24 18.4338 24 12.4443Z" fill="#98A2B3"/>
             </g>
             <defs>
             <clipPath id="clip0_1701_13593">
             <rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
             </clipPath>
             </defs>
             </svg>
                    </a>
                    <a target='_blank' href='https://whatsapp.com/channel/0029VaEaZQc0VycP5QuEhD3E ' title="WhatsApp">
                    <svg className='whatsapp' fill="#000000" height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
	 viewBox="0 0 308 308">
<g id="XMLID_468_">
	<path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"/>
	<path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"/>
</g>
</svg>
                    </a>
                </div>
            </div>


        </footer>

    </>
    )
}